export default "__VITE_ASSET__T7HR87Ao__"